
import React, { Component } from 'react';
import HavenNav from '../HavenNav/HavenNav';
import JobStatus from '../JobStatus/JobStatus'
import MyInfo from '../MyInfo/MyInfo';
import MyDocs from '../MyDocs/MyDocs';
import ContactUs from '../ContactUs/ContactUs';
import { showReferrals, hideReferrals } from '../../../../Actions/showReferralsAction'
import Loader from 'react-loader-spinner'

import { connect } from 'react-redux'
import {authenticate} from '../../../../Actions/authAction'
import './Dashboard.css';
import {Redirect} from 'react-router-dom'

import MonitoringJumbo from '../MonitoringJumbo/MonitoringJumbo'
import PageHeader from '../PageHeader/PageHeader';
import InformationCards from '../InformationCards/InformationCards';
import SavedRow from '../InformationCards/SavedRow';



class Dashboard extends Component {
    state = {
        timeline: "https://firebasestorage.googleapis.com/v0/b/westhaven-solar.appspot.com/o/Timeline%20Images%2Ftimeline1.png?alt=media&token=45b50846-0afb-419a-9e59-810cc9c9a9ce",
        loading : true,
        nextStep: "This is the next step of the job.",
        progressbar: "progress-bar-10", 
        savedAmount: "0",
        lifetimeAmount: "0",
        currentPower: "0",
        today: '',
        month: '',
        year: '',
        sevenDaysAgo: '',
        lastYear: '',
        monthAsWord: '',
        mayCurrent: ''

    }
        componentWillMount = () => {
            this.todaysDateFunction();

        };
    //get todays date 
    todaysDateFunction = () => {
        var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth()+1; //January is 0!
        var yyyy = today.getFullYear();
        //getting 7 days ago
        var sevenDaysAgo = new Date(today);
        sevenDaysAgo.setDate(today.getDate() - 7);
        
        var ydd = sevenDaysAgo.getDate();
        var ymm = sevenDaysAgo.getMonth()+1;
        var yYYYY = sevenDaysAgo.getFullYear();
      
        if(ydd<10) {
            dd = dd
        } 
        if(ymm<10) {
            mm = mm
        } 
        sevenDaysAgo = ymm + '/' + ydd + '/' + yYYYY

        if(dd<10) {
            dd = dd
        } 
        if(mm<10) {
            mm = mm
        } 
        today = mm + '/' + dd + '/' + yyyy;

        this.setState({
            month: mm,
            year: yyyy,
            today: today,
            sevenDaysAgo: sevenDaysAgo,
            lastYear: yyyy - 1
        })

        //for the month label on the monthly chart
        if (mm === 1) {
            this.setState({
                monthAsWord: 'January'
            })
        }
        if (mm === 2) {
            this.setState({
                monthAsWord: 'February'
            })
        }
        if (mm === 3) {
            this.setState({
                monthAsWord: 'March'
            })
        }
        if (mm === 4) {
            this.setState({
                monthAsWord: 'April'
            })
        }
        if (mm === 5) {
            this.setState({
                monthAsWord: 'May'
            })
        }
        if (mm === 6) {
            this.setState({
                monthAsWord: 'June'
            })
        }
        if (mm === 7) {
            this.setState({
                monthAsWord: 'July'
            })
        }
        if (mm === 8) {
            this.setState({
                monthAsWord: 'August'
            })
        }
        if (mm === 9) {
            this.setState({
                monthAsWord: 'September'
            })
        }
        if (mm === 10) {
            this.setState({
                monthAsWord: 'October'
            })
        }
        if (mm === 11) {
            this.setState({
                monthAsWord: 'November'
            })
        }
        if (mm === 12) {
            this.setState({
                monthAsWord: 'December'
            })
        }
    }

  

    render() { 

        if(this.props.email === null) {
            return (
                <div style={{ textAlign: "center", position: "absolute", top: "50%", left: "50%", marginTop: "-50px", marginLeft: "-50px", width: "100px", height: "100px" }}>
                <Loader 
                    type="TailSpin"
                    color="#001e61"
                    height="100"	
                    width="100"
                /> 
            </div>
            )
        }

        if(this.props.role === "Referrals"){
            return <Redirect to="/dashboard/referrals" />
        }

        return ( 
            <div className='dash-wrapper'>
                <HavenNav />
            
               
                {
                    this.props.jobstatus === "Complete" ? 
                    <div>
                        <div className="container">
                        {
                            this.props.monitoring === "SolarEdge" ? 
                                <div className="row savedRow">
                                    <div className="col-xl-4 text-center">
                                    <h3 className="miniHeadings" style={{textAlign: "left", position: "absolute"}}>Hey {this.props.firstName}, </h3>
                                        <SavedRow title="Over the lifetime of your system, you have saved " moneyDisplay="block" treeDisplay="none" smokeDisplay="none" icon="fas fa-money-bill-alt" styleColor="#001e61" body={'$'  + this.props.saved}/>                                
                                    </div>
                                    <div className="col-xl-4 text-center">
                                        <SavedRow title="Your system has also saved  " icon="fas fa-cloud" moneyDisplay="none" treeDisplay="none" smokeDisplay="block" styleColor="#cc2222"  body={this.props.co2 + " kg CO2 emmissions..."} />
                                    </div>
                                    <div className="col-xl-4 text-center">
                                        <SavedRow title="which is the equivalent of " icon="fas fa-tree" moneyDisplay="none" treeDisplay="block" smokeDisplay="none" styleColor="#04a200"  body={this.props.trees + " trees being planted."} />
                                    </div>
                            </div>
                            : <div></div>
                        }
                            
                        </div>
                        
                        <div className="container">
                            <MonitoringJumbo 
                                monitoring = {this.props.monitoring}
                                twelveA={this.props.hoursInDay.twelveA}
                                oneA={this.props.hoursInDay.oneA}
                                twoA={this.props.hoursInDay.twoA}
                                threeA={this.props.hoursInDay.threeA}
                                fourA={this.props.hoursInDay.fourA}
                                fiveA={this.props.hoursInDay.fiveA}
                                sixA={this.props.hoursInDay.sixA}
                                sevenA={this.props.hoursInDay.sevenA}
                                eightA={this.props.hoursInDay.eightA}
                                nineA={this.props.hoursInDay.nineA}
                                tenA={this.props.hoursInDay.tenA}
                                elevenA={this.props.hoursInDay.elevenA}
                                twelveP={this.props.hoursInDay.twelveP}
                                oneP={this.props.hoursInDay.oneP}
                                twoP={this.props.hoursInDay.twoP}
                                threeP={this.props.hoursInDay.threeP}
                                fourP={this.props.hoursInDay.fourP}
                                fiveP={this.props.hoursInDay.fiveP}
                                sixP={this.props.hoursInDay.sixP}
                                sevenP={this.props.hoursInDay.sevenP}
                                eightP={this.props.hoursInDay.eightP}
                                nineP={this.props.hoursInDay.nineP}
                                tenP={this.props.hoursInDay.tenP}
                                elevenP={this.props.hoursInDay.elevenP}

                                firstWeek={this.props.lastWeekOfData.First}
                                secondWeek={this.props.secondWeek}
                                thirdWeek={this.props.thirdWeek}
                                fourthWeek={this.props.fourthWeek}
                                fifthWeek={this.props.fifthWeek}
                                sixthWeek={this.props.sixthWeek}
                                seventhWeek={this.props.seventhWeek}
                                
                                saved={this.props.saved}
                                current={this.props.current}
                                energyMonth={this.props.energyMonth}
                                energyToday={this.props.energyToday}
                                lifetime={this.props.lifetime}
                                co2={this.props.co2}
                                trees={this.props.trees}

                                janCurrent={this.props.monthsInYear.Jan}
                                febCurrent={this.props.monthsInYear.Feb}
                                marchCurrent={this.props.monthsInYear.March}
                                aprilCurrent={this.props.monthsInYear.April}
                                mayCurrent={this.props.monthsInYear.May}
                                juneCurrent={this.props.monthsInYear.June}
                                julyCurrent={this.props.monthsInYear.July}
                                augCurrent={this.props.monthsInYear.Aug}
                                septCurrent={this.props.monthsInYear.Sept}
                                octCurrent={this.props.monthsInYear.Oct}
                                novCurrent={this.props.monthsInYear.Nov}
                                decCurrent={this.props.monthsInYear.Dec}

                                janPrevious={this.props.previousMonthsInYear.Jan}
                                febPrevious={this.props.previousMonthsInYear.Feb}
                                marchPrevious={this.props.previousMonthsInYear.March}
                                aprilPrevious={this.props.previousMonthsInYear.April}
                                mayPrevious={this.props.previousMonthsInYear.May}
                                junePrevious={this.props.previousMonthsInYear.June}
                                julyPrevious={this.props.previousMonthsInYear.July}
                                augPrevious={this.props.previousMonthsInYear.Aug}
                                septPrevious={this.props.previousMonthsInYear.Sept}
                                octPrevious={this.props.previousMonthsInYear.Oct}
                                novPrevious={this.props.previousMonthsInYear.Nov}
                                decPrevious={this.props.previousMonthsInYear.Dec}

                                monthAsWord = {this.state.monthAsWord}
                                month={this.state.month}
                                year={this.state.year}
                                today={this.state.today}
                                sevenDaysAgo={this.state.sevenDaysAgo}
                                lastYear = {this.state.lastYear}

                            
                                firstDayOfMonth={this.props.daysInMonth.First} secondDayOfMonth={this.props.daysInMonth.Second} thirdDayOfMonth={this.props.daysInMonth.Third}
                                fourthDayOfMonth={this.props.daysInMonth.Fourth} fifthDayOfMonth={this.props.daysInMonth.Fifth} sixthDayOfMonth={this.props.daysInMonth.Sixth}
                                seventhDayOfMonth={this.props.daysInMonth.Seventh} eighthDayOfMonth={this.props.daysInMonth.Eighth} ninthDayOfMonth={this.props.daysInMonth.Ninth}
                                tenthDayOfMonth={this.props.daysInMonth.Tenth} eleventhDayOfMonth={this.props.daysInMonth.Eleventh} twelfthDayOfMonth={this.props.daysInMonth.Twelfth}
                                thirteenthDayOfMonth={this.props.daysInMonth.Thirteenth} fourteenthDayOfMonth={this.props.Fourteenth} fifteethDayOfMonth={this.props.Fifteenth}
                                sixteenthDayOfMonth={this.props.daysInMonth.Sixteenth} seventeenthDayOfMonth={this.props.Seventeenth} eighteenthDayOfMonth={this.props.Eighteenth}
                                nineteenthDayOfMonth={this.props.daysInMonth.Nineteenth} twentiethDayOfMonth={this.props.Twentieth} twentyFirstDayofMonth={this.props.TwentyFirst}
                                twentySecondDayOfMonth={this.props.daysInMonth.TwentySecond} twentyThirdDayOfMonth={this.props.TwentyThird} twentyFourthDayOfMonth={this.props.TwentyFourth}
                                twentyFifthDayOfMonth={this.props.daysInMonth.TwentyFifth} twentySixthDayOfMonth={this.props.TwentySixth} twentySeventhDayOfMonth={this.props.TwentySeventh}
                                twentyEighthDayOfMonth={this.props.TwentyEighth} twentyNinthDayOfMonth={this.props.TwentyNinth} thirtiethDayOfMonth = {this.props.Thirtieth} 
                                thirtyFirstDayOfMonth={this.props.ThirtyFirst}
                                
                            />
                        </div>
                    </div>
                :   <div className="container">
                        <div className="row">
                            <JobStatus jobstatus ={this.props.jobstatus}/>
                        </div>
                    </div>
                }
                <div className="container second-row">
                <hr/>
                    <div className="row">
                        <div className="col-xl-6">
                        <h3 className="miniHeadings" style={{marginLeft: "10px", marginBottom: "0"}}>My Docs</h3>
                            <InformationCards title="" style="" icon="fas fa-pen-square" document={this.props.contract} iconColor="#b93088" hover="informationHover" body="Contract" display="none" columnClass="col-xl-12"/>
                            <InformationCards title="" style="" icon="far fa-image" document={this.props.siteplans} iconColor="#b93088" hover="informationHover" body="Site Plans" display="none" columnClass="col-xl-12"/>
                           
                        </div>
                        <div className="col-xl-6">
                        <div style={{marginTop: "25px"}}></div>
                            <InformationCards title="" style="" icon="far fa-file-alt" document={this.props.permit} iconColor="#b93088" hover="informationHover" body="Permit" display="none" columnClass="col-xl-12"/>
                            <InformationCards title="" style="" icon="far fa-file" document={this.props.nem} iconColor="#b93088" hover="informationHover" body="NEM Receipt" display="none" columnClass="col-xl-12"/>
                        </div>
                      
                    </div>
                   
                </div> 
            </div>
         )
    }
}

const mapStateToProps = state => ({
    firstName: state.firebase.firstName,
    lastName: state.firebase.lastName,
    address: state.firebase.address,
    contract: state.firebase.contract, 
    jobstatus: state.firebase.jobstatus,
    monitoring: state.firebase.monitoring,
    nem: state.firebase.nem,
    permit: state.firebase.permit, 
    phonenumber: state.firebase.phonenumber,
    powrguard: state.firebase.powrguard,
    role: state.firebase.role,
    salesrepemail: state.firebase.salesrepemail,
    salestype: state.firebase.salestype,
    salesrep: state.firebase.salesrep,
    siteplans: state.firebase.siteplans,
    systemsize: state.firebase.systemsize,
    zipcode: state.firebase.zipcode,
    email: state.firebase.email,
    customer: state.firebase.customer,
    //Daily Data
    twelveA: state.firebase.twelveA,
    oneA: state.firebase.oneA,
    twoA: state.firebase.twoA,
    threeA: state.firebase.threeA,
    fourA: state.firebase.fourA,
    fiveA: state.firebase.fiveA,
    sixA: state.firebase.sixA,
    sevenA: state.firebase.sevenA,
    eightA: state.firebase.eightA,
    nineA: state.firebase.nineA,
    tenA: state.firebase.tenA,
    elevenA: state.firebase.elevenA,
    twelveP: state.firebase.twelveP,
    oneP: state.firebase.oneP,
    twoP: state.firebase.twoP,
    threeP: state.firebase.threeP,
    fourP: state.firebase.fourP,
    fiveP: state.firebase.fiveP,
    sixP: state.firebase.sixP,
    sevenP: state.firebase.sevenP,
    eightP: state.firebase.eightP,
    nineP: state.firebase.nineP,
    tenP: state.firebase.tenP,
    elevenP: state.firebase.elevenP,
    //Non Chart Data
    saved: state.firebase.saved,
    current: state.firebase.current,
    energyMonth: state.firebase.energyMonth,
    energyToday: state.firebase.energyToday,
    lifetime: state.firebase.lifetime,
    co2: state.firebase.co2,
    trees: state.firebase.trees,

    //annual data
    monthsInYear: state.annuallyChart.monthsInYear,
    //monthly data
    daysInMonth: state.monthlyChart.daysInMonth,
    //daily data
    hoursInDay: state.dailyChart.hoursInDay,
    //weekly data
    lastWeekOfData: state.weeklyChart.lastWeekOfData,    
    //previous annually
    previousMonthsInYear: state.previousAnnuallyChart.previousMonthsInYear,

})
const mapDispatchToProps = (dispatch) => {
    return {
      
        showReferrals: () => dispatch(showReferrals("")),
        hideReferrals: () => dispatch(hideReferrals(""))
  }
}
export default connect(mapStateToProps, mapDispatchToProps) (Dashboard);



// WEBPACK FOOTER //
// ./src/Components/Pages/MyHaven/Dashboard/Dashboard.jsx